import React, { useState } from 'react'
import styles from './Footer.module.scss'
// import phoneIcon from '@assets/img/phone.png'
import emailIcon from '@assets/img/email.png'
import dianpingDownload from '@assets/img/dianpingDownload.png'
import meituanDownload from '@assets/img/meituanDownload.png'
import travelDownload from '@assets/img/travelDownload.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createMerchantI18n } from '@/utils/i18n'

// 区域运营联系人（编号 1..18）。默认仅展示前 3 个，点击「查看全部」展开全部。
const EMPLOYEES = [
  { id: 1, contact: 'Liang Fangqi，TEL：(+86)18782273279，WhatsApp：(+86)18782273279，Email：liangfangqi@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 2, contact: 'Tan Jing，TEL：(+86)18523476330，WhatsApp：(+86)18523476330，Email：tanjing14@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 3, contact: 'Liu Yuehong，TEL：(+86)13551100987，WhatsApp：(+86)13551100987，Email：liuyuehong@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 4, contact: 'Li Huajuan，TEL：(+86)15891843468，WhatsApp：(+86)15891843468，Email：lihuajuan@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 5, contact: 'Geng Yifan，TEL：(+86)13134720892，WhatsApp：(+86)17621329890，Email：gengyifan@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 6, contact: 'Shu Haojie，TEL：(+86)18908164174，WhatsApp：(+86)18908164174，Email：shuhaojie@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 7, contact: 'Wang Tong，TEL：(+86)18782418541，WhatsApp：(+86)18782418541，Email：wangtong65@meituan.com', desc: 'Regional Operations – Southeast Asia/Hong Kong/Macau, China' },
  { id: 8, contact: 'Shi Caogan，TEL：(+86)18342680317，WhatsApp：(+86)18342680317，Email：shicaogan@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 9, contact: 'Ceng Rui，TEL：(+86)18224070790，WhatsApp：(+86)18224070790，Email：cengrui@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 10, contact: 'Luo Juhao，TEL：(+86)13068669495，WeChat：(+86)13068669495，Email：luojuhao@meituan.com', desc: 'Regional Operations – Hong Kong/Macau' },
  { id: 11, contact: 'Jiang Xian，TEL：(+86)13340635194，WhatsApp：(+86)13340635194，Email：jiangxian03@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 12, contact: 'Mou Chengyu，TEL：(+86)19982081850，WhatsApp：(+86)19982081850，Email：mouchengyu@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 13, contact: 'Pan Yuxin，TEL：(+86)17868784348，WhatsApp：(+86)17868784348，Email：panyuxin06@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 14, contact: 'Zhang Junlong，TEL：(+86)13990703717，WhatsApp：(+86)13990703717，Email：zhangjunlong@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 15, contact: 'Li Haoyun，TEL：(+86)13086411888，WhatsApp：(+86)13086411888，Email：lihaoyun03@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 16, contact: 'Yang Panjing，TEL：(+86)18628176190，WhatsApp：(+86)18628176190，Email：yangpanjing02@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 17, contact: 'Li Xuan，TEL：(+86)13881961202，WhatsApp：(+86)13881961202，Email：lixuan73@meituan.com', desc: 'Regional Operations – Southeast Asia' },
  { id: 18, contact: 'Chen Xingyu，TEL：(+86)15378235735，WhatsApp：(+86)15378235735，Email：chenxingyu36@meituan.com', desc: 'Regional Operations – Southeast Asia' },
] as const

// 折叠态默认展示的联系人数量
const COLLAPSED_COUNT = 3

const Footer: React.FC<WithI18nProps> = (props) => {
  const { i18n } = props
  const t = React.useMemo(() => createMerchantI18n(i18n), [i18n])
  // 联系人列表默认折叠：仅展示前 3 个，点击「查看全部」后展开全部
  const [expanded, setExpanded] = useState(false)
  const visibleEmployees = expanded ? EMPLOYEES : EMPLOYEES.slice(0, COLLAPSED_COUNT)

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContent}>
        <div className={styles.leftInfo}>
          <div className={styles.title}>{t('contactUs', "联系我们")}</div>
          {/* <div className={styles.contactRow}>
            <div className={styles.icon}><img src={phoneIcon} alt="phone" /></div>
            <div className={styles.contactItem}>
              10105557
            </div>
          </div> */}
          {/* <div className={styles.sub}>{t('contactUsDescription', "平台客服热线（周一至周五 9:00-23:00）")}</div> */}

          <div className={styles.contactRow}>
            <div className={styles.icon}><img src={emailIcon} alt="email" /></div>
            <div className={styles.contactItem}>
              hb.overseas.sot@meituan.com
            </div>
          </div>
          <div className={styles.sub}>{t('contactUsEmailDescription', "商务合作邮箱")}</div>

          <div className={styles.employeeList}>
            {visibleEmployees.map((employee) => (
              <div className={styles.employeeItem} key={employee.id}>
                <div className={styles.contactItem}>
                  {t(`contactUsEmployee${employee.id}`, employee.contact)}
                </div>
                <div className={styles.sub}>{t(`contactUsEmployee${employee.id}Description`, employee.desc)}</div>
              </div>
            ))}

            {!expanded && EMPLOYEES.length > COLLAPSED_COUNT && (
              <div
                className={styles.viewAllBtn}
                onClick={() => setExpanded(true)}
              >
                {t('contactUsViewAll', 'ALL')}
              </div>
            )}
          </div>

        </div>
        {/* <div className={styles.divider} /> */}


        <div className={styles.rightApps}>
          <div className={styles.title}>{t('downloadApplications', "下载应用")}</div>
          <div className={styles.qrGrid}>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={dianpingDownload} alt="dianpingDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadDianping', "大众点评")}</div>
            </div>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={meituanDownload} alt="meituanDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadMeituan', "美团")}</div>
            </div>
            <div className={styles.qrItem}>
              <div className={styles.qrBox}><img src={travelDownload} alt="travelDownload" /></div>
              <div className={styles.qrText}>{t('scanDownloadTravel', "美团境外商家")}</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

const FooterWithTranslator = withTranslator(Footer)
export default FooterWithTranslator
